import { render } from "./NotificationComponent.vue?vue&type=template&id=30a52136&scoped=true"
import script from "./NotificationComponent.vue?vue&type=script&lang=js"
export * from "./NotificationComponent.vue?vue&type=script&lang=js"

import "./NotificationComponent.vue?vue&type=style&index=0&id=30a52136&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30a52136"]])

export default __exports__